import { combineReducers } from 'redux'
import { userReducer } from './user/reducers'
import { onboardReducer } from './onboarding/reducers';

// Keys will correspond to folder name within store
export default combineReducers({
    user: userReducer,
    onboarding: onboardReducer
})